import { createAction } from 'redux-actions'

export const APP_STEP = {
  START_UP: 0,
  CONNECT_TO_PORTAL: 1,
  RTC_RESTARTING: 2,
  RTC_START: 3,
  RTC_WAIT_CONFIRM_ACCESS: 4,
  RUNNING: 5,
  CLOSING: 6,
  CLOSED: 7,
}

const API_CONFIG_RESOLVED = 'API_CONFIG_RESOLVED'
const STEP = 'STEP'
const MESSAGE = 'MESSAGE'
const START_SESSION = 'START_SESSION'
const START_RTC = 'START_RTC'
const RESTART_RTC = 'RESTART_RTC'
const UPDATE_FEATURES = 'UPDATE_FEATURES'

export const apiConfigResolved = createAction(API_CONFIG_RESOLVED)
export const step = createAction(STEP)
export const message = createAction(MESSAGE)
export const startSession = createAction(START_SESSION)
export const startRTC = createAction(START_RTC)
export const restartRTC = createAction(RESTART_RTC)
export const updateFeatures = createAction(UPDATE_FEATURES)
